<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '보수일' },
        { type: 'text', label: '점검장소' },
      ]"
      :board="this.board"
      :is-print="isPrint"
      @selectField="onSelectFieldSelector"
    />

    <!-- 시설물 개요 -->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i>{{ $t('시설물 개요') }}</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer mt-4">
        <div>
          <div>{{ $t('시설물명') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <ml-input v-else v-model="form.inputA_1" readonly />
        </div>
        <div>
          <div>{{ $t('담당 주무관') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <ml-input v-else v-model="form.inputA_2" readonly />
        </div>
        <div class="hidden xl:block"></div>
        <div>
          <div>{{ $t('준공일') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_3 }}</p>
          <date-selector v-else v-model="form.inputA_3" readonly />
        </div>
        <div>
          <div>{{ $t('사업금액') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_4 }}</p>
          <ml-input v-else v-model="form.inputA_4" readonly />
        </div>
        <div>
          <div>{{ $t('시설물 위치(주소)') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_5 }}</p>
          <ml-input v-else v-model="form.inputA_5" readonly />
        </div>
        <div>
          <div>{{ $t('구분') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_6 }}</p>
          <ml-input v-else v-model="form.inputA_6" readonly />
        </div>
        <div>
          <div>{{ $t('종류') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_7 }}</p>
          <ml-input v-else v-model="form.inputA_7" readonly />
        </div>
        <div>
          <div>{{ $t('세분류') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_8 }}</p>
          <ml-input v-else v-model="form.inputA_8" readonly />
        </div>
        <div>
          <div>{{ $t('종별') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_9 }}</p>
          <ml-input v-else v-model="form.inputA_9" readonly />
        </div>
        <div>
          <div>{{ $t('안전 등급') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_10 }}</p>
          <ml-input v-else v-model="form.inputA_10" readonly />
        </div>
        <div>
          <div>{{ $t('형식') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_11 }}</p>
          <ml-input v-else v-model="form.inputA_11" readonly />
        </div>
        <div>
          <div>{{ $t('규모1') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_12 }}</p>
          <ml-input v-else v-model="form.inputA_12" readonly />
        </div>
        <div>
          <div>{{ $t('규모2') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_13 }}</p>
          <ml-input v-else v-model="form.inputA_13" readonly />
        </div>
        <div>
          <div>{{ $t('규모3') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_14 }}</p>
          <ml-input v-else v-model="form.inputA_14" readonly />
        </div>
      </div>
    </div>

    <!-- 개선 계획 -->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i>{{ $t('개선 계획') }}</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer mt-4">
        <div>
          <div>{{ $t('방법') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <multiselect v-else :options="multiselectList1" v-model="form.inputB_1" multiple placeholder="" />
        </div>
        <div v-show="form.inputB_1.includes('직접입력')">
          <div>{{ $t('직접입력') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <ml-input v-else v-model="form.inputB_2" />
        </div>
      </div>
      <div class="writeGridContainer mt-4">
        <div>
          <div>{{ $t('주체') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
          <multiselect v-else :options="multiselectList2" v-model="form.inputB_3" multiple placeholder="" />
        </div>
        <div v-show="form.inputB_3.includes('직접입력')">
          <div>{{ $t('직접입력') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <ml-input v-else v-model="form.inputB_4" />
        </div>
      </div>
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" />

    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import Multiselect from "vue-multiselect";

export default {
  components: {
    FileUploadModule,
    DateSelector,
    FieldSelectModule,
    PhotoUploadGridModule,
    Multiselect,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        photoList: [],

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",
        inputA_9: "",
        inputA_10: "",
        inputA_11: "",
        inputA_12: "",
        inputA_13: "",
        inputA_14: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",

        fileList: [],
      },
      multiselectList1: ["점검", "진단", "보수", "보강", "교체", "기타", "직접입력"],
      multiselectList2: ["직접", "도급", "용역", "위탁", "기타", "직접입력"],
    };
  },
  methods: {
    onSelectFieldSelector(value) {
      this.form.inputA_1 = value.field_name; // 담당 주무관
      this.form.inputA_2 = value.manager_name; // 담당 주무관
      this.form.inputA_3 = value.be_completed_at; // 준공일
      this.form.inputA_4 = value.deposit_amount; // 계약금액
      this.form.inputA_5 = value.address; // 시설물 위치

      if (value.facility_category) {
        this.form.inputA_6 = value.facility_category.cat1; // 구분
        this.form.inputA_7 = value.facility_category.cat2; // 종류
        this.form.inputA_8 = value.facility_category.cat3; // 세분류
        this.form.inputA_9 = value.facility_category.classification; // 종별
      }

      this.form.inputA_10 = value.safety_grade; // 안전등급
      this.form.inputA_11 = value.format; // 형식
      this.form.inputA_12 = value.scale1; // 규모1
      this.form.inputA_13 = value.scale2; // 규모2
      this.form.inputA_14 = value.scale3; // 규모3
    },
  },
};
</script>
